import { init, last, not, tail, zip } from '@skylab-shared/utils';
import { NumberingToken, NumberingTokenType } from './numbering-format-lexer';

export const isNumberTokenInTokens = (tokens: NumberingToken[]) => tokens.some(token => token.type === 'number');

export const isAnyDateTokenInTokens = (tokens: NumberingToken[]) => tokens.some(isDateToken);

export const hasAnyDateTokenAsterisk = (tokens: NumberingToken[]) => tokens
    .filter(isDateToken)
    .some(token => token.asterisk);

export const doDateTokensRescpectAsteriskRule = (tokens: NumberingToken[]) => {
    const dateTokens = filterAndSortDateTokens(tokens);
    return zip(init(dateTokens), tail(dateTokens))
        .reduceRight((result, [prev, curr]) => result && not(prev.asterisk && !curr.asterisk), last(dateTokens)?.asterisk ?? true);
};

export const isAnyNotAllowedTagUsed = (tokens: NumberingToken[]) => tokens
    .filter(token => token.type === 'const')
    .some(token => /\[.+\]/.test(token.content));

const filterAndSortDateTokens = (tokens: NumberingToken[]) => tokens.filter(isDateToken).sort(dateTokenComparer);

const isDateToken = (token: NumberingToken) => dateTokensOrder.includes(token.type);

const dateTokenComparer = (a: NumberingToken, b: NumberingToken) => dateTokensOrder.indexOf(a.type) - dateTokensOrder.indexOf(b.type);

const dateTokensOrder = <NumberingTokenType[]> ['day', 'month', 'year'];
